module.exports = __webpack_public_path__ + "img/Priest-undead-m-60.60342eeb.gif";